function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useHistory } from 'react-router';
import { useTestIds } from 'seagull/utils/TestIds';
import { routes } from "../../../constants";
import { useIoContext, useStoreActions } from "../../../contexts";
import { integrationModel } from "../../../models";
import IntegrationCard from "../IntegrationCard/IntegrationCard";
import financialCentsLogoUrl from "./financial-cents-logo.png";
import { jsx as _jsx } from "react/jsx-runtime";
export const deprecatedTestIds = {
  /**
   * @deprecated - don't add new key here!!!!
   * This is for backward compatibility during migration.
   * Remove keys one by one after tests are migrated.
   */
  FinancialCentsCardTID: {
    Root: () => 'financial-cents-card',
    Connect: () => 'financial-cents-connect',
    ManageConnection: () => 'financial-cents-manage-connection'
  }
};
const FinancialCentsCard = _ref => {
  let {
    integration
  } = _ref;
  const {
    FinancialCentsCardTID
  } = useTestIds({
    deprecatedTestIds
  });
  const {
    api
  } = useStoreActions();
  const {
    changeLocation
  } = useIoContext();
  const history = useHistory();
  const isLinked = integrationModel.isLinked(integration);
  const buttonProps = isLinked ? {
    'data-testid': FinancialCentsCardTID.ManageConnection(),
    children: 'Manage connection',
    onClick: () => history.push(routes.financialCentsSetup)
  } : {
    'data-testid': FinancialCentsCardTID.Connect(),
    children: 'Connect',
    onClick: async () => {
      const redirectUrl = "".concat(window.location.origin).concat(routes.financialCentsSetup);
      const linkUrl = await api.financialCents.connect(redirectUrl);
      const connectUrl = new URL(linkUrl);
      connectUrl.searchParams.append('host', window.location.host);
      changeLocation(connectUrl.toString());
    }
  };
  return /*#__PURE__*/_jsx(IntegrationCard, {
    "data-testid": FinancialCentsCardTID.Root(),
    title: "Financial Cents",
    subTitle: "Connect your account for efficient workflows between your team and your clients",
    mainAction: /*#__PURE__*/_jsx(IntegrationCard.MainActionButton, _objectSpread({}, buttonProps)),
    icon: /*#__PURE__*/_jsx(IntegrationCard.LogoImg, {
      alt: "financial cents logo",
      src: financialCentsLogoUrl
    }),
    disclaimer: "* Requires the Scale plan in Financial Cents"
  });
};
export default FinancialCentsCard;